export const panelConstants = {
    GETALL_REQUEST: 'PANEL_GETALL_REQUEST',
    GETALL_SUCCESS: 'PANEL_GETALL_SUCCESS',
    GETALL_FAILURE: 'PANEL_GETALL_FAILURE',

    DELETE_REQUEST: 'PANEL_DELETE_REQUEST',
    DELETE_SUCCESS: 'PANEL_DELETE_SUCCESS',
    DELETE_FAILURE: 'PANEL_DELETE_FAILURE'
};
